import React from 'react';
import PropTypes from 'prop-types';
import { groupMemberShape } from 'AppSrc/core/data-structures/api-proptypes';
import 'AppSrc/core/components/forms/select-coordinator/view-crq-select-individual-approver.css';

const ApprovalButton = ({
  groupMembers,
  setCoordinator,
  onClickDisappear,
  isViewOnly,
  isAssign,
  isReAssign,
  approverCall,
  network,
  crqId,
  buttonName,
  onClickAssign,
  approvalSignature,
  groupId,
  slectedNetwork,
}) => {
  console.log('testing purpose');
  return (
    <React.Fragment>
      <div className="assign-to-me-container">
        <button
          className="assign-to-me"
          type="button"
          onClick={(networkType, groupid, buttonType, approvalrequestId) => onClickAssign(slectedNetwork, groupId, buttonName, approvalSignature)}
        >
          {buttonName}
        </button>
      </div>
    </React.Fragment>
  );
};

ApprovalButton.propTypes = {
  groupMembers: PropTypes.arrayOf(groupMemberShape),
  setCoordinator: PropTypes.func,
  onClickDisappear: PropTypes.func,
  network: PropTypes.string,
  crqId: PropTypes.string,
  approverCall: PropTypes.func,
  isViewOnly: PropTypes.bool,
  isAssign: PropTypes.bool,
  isReAssign: PropTypes.bool,
  onClickAssign: PropTypes.func,
  groupId: PropTypes.string,
  buttonName: PropTypes.string,
  slectedNetwork: PropTypes.string,
  approvalSignature: PropTypes.string,
};

export {
  ApprovalButton,
};
